module.exports = __webpack_public_path__ + "media/images/logo-c21733babddd79332be18092c1c11aa6.svg";